import Box from '@mui/material/Box';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import GoogleContactImport from '../../components/Settings/ContactImport/GoogleContactImport';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: theme.palette.menuListHover.main,
    },
    box: {
        paddingTop: theme.spacing(5),
        width: '70%',
    },
}));

export default function ImportExportPage() {
    const { classes } = useStyles();

    return (
        <React.Fragment>
            <div className={classes.root}>
                <Box px={2} className={classes.box}>
                    <GoogleContactImport />
                </Box>
            </div>
        </React.Fragment>
    );
}
